/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Service } from "@cxp-shared/platform/Service";
var MktFeatureServiceClient = /** @class */ (function (_super) {
    __extends(MktFeatureServiceClient, _super);
    function MktFeatureServiceClient(crmUrl, fetchClient, configProvider) {
        var _this = _super.call(this) || this;
        _this.crmUrl = crmUrl;
        _this.fetchClient = fetchClient;
        _this.configProvider = configProvider;
        return _this;
    }
    MktFeatureServiceClient.prototype.isFeatureAvailable = function (featureId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.areFeaturesAvailable([featureId])];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, (result === null || result === void 0 ? void 0 : result.length) > 0 ? result[0].available : false];
                }
            });
        });
    };
    MktFeatureServiceClient.prototype.isFeatureEnabled = function (featureId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.areFeaturesEnabled([featureId])];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, (result === null || result === void 0 ? void 0 : result.length) > 0 ? result[0].enabled : false];
                }
            });
        });
    };
    MktFeatureServiceClient.prototype.areFeaturesAvailable = function (featureIds) {
        return __awaiter(this, void 0, void 0, function () {
            var features;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAvailableFeatures()];
                    case 1:
                        features = _a.sent();
                        return [2 /*return*/, featureIds.map(function (id) {
                                var feature = features.filter(function (k) { return k.featureId === id; })[0];
                                return {
                                    featureId: id,
                                    entityType: feature === null || feature === void 0 ? void 0 : feature.entity,
                                    available: (feature === null || feature === void 0 ? void 0 : feature.isAvailable) === true,
                                    existing: feature != null,
                                    description: feature === null || feature === void 0 ? void 0 : feature.description,
                                    name: feature === null || feature === void 0 ? void 0 : feature.name,
                                    group: feature === null || feature === void 0 ? void 0 : feature.group,
                                    webresource: feature === null || feature === void 0 ? void 0 : feature.webresource,
                                    showConsentLevelSelectBox: feature === null || feature === void 0 ? void 0 : feature.showConsentLevelSelectBox,
                                    isHidden: feature === null || feature === void 0 ? void 0 : feature.isHidden,
                                    isPrivatePreview: feature === null || feature === void 0 ? void 0 : feature.isPrivatePreview
                                };
                            })];
                }
            });
        });
    };
    MktFeatureServiceClient.prototype.areFeaturesEnabled = function (featureIds, additionalFields) {
        if (additionalFields === void 0) { additionalFields = []; }
        return __awaiter(this, void 0, void 0, function () {
            var entities;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.configProvider.provideMultiple(featureIds.map(function (feature) { return ({
                            featureId: feature,
                            entityType: MktFeatureServiceClient.entity,
                            additionalFields: additionalFields
                        }); }))];
                    case 1:
                        entities = _a.sent();
                        return [2 /*return*/, featureIds.map(function (featureId) {
                                var entity = entities[featureId];
                                return {
                                    featureId: featureId,
                                    enabled: !!entity && entity.msdyncrm_featurestate === MktFeatureServiceClient.FeatureEnabled,
                                    requiredConsent: !!entity ? entity.msgdpr_requiredconsent : null
                                };
                            })];
                }
            });
        });
    };
    MktFeatureServiceClient.prototype.getAvailableFeatures = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = "".concat(this.crmUrl, "/api/data/v9.0/webresourceset/?$select=name,content&$filter=endswith(name, '").concat(MktFeatureServiceClient.webResourceSuffix, "')");
                        return [4 /*yield*/, this.fetchClient.get(url)];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, (_a = []).concat.apply(_a, __spreadArray([], __read(response.value.map(function (k) {
                                var defs = JSON.parse(atob(k.content));
                                defs.forEach(function (element) { return element.webresource = k.name; });
                                return defs;
                            })), false))];
                }
            });
        });
    };
    MktFeatureServiceClient.prototype.isFCSEnabled = function (namespace, key) {
        var globalContext = window.Xrm.Utility.getGlobalContext();
        return globalContext.getFeatureControlSetting(namespace, key);
    };
    MktFeatureServiceClient.prototype.isFCBEnabled = function (key) {
        return Xrm.Internal.isFeatureEnabled(key);
    };
    // This value is defined in the Option Set on the configuration entity
    MktFeatureServiceClient.FeatureEnabled = 192350010;
    MktFeatureServiceClient.webResourceSuffix = ".featureDefinition.json";
    MktFeatureServiceClient.entity = "msdyncrm_featureconfiguration";
    return MktFeatureServiceClient;
}(Service));
export { MktFeatureServiceClient };
